<template>
  <div>

    <el-form-item :label="(itemIndex + 1) + '.' + formItemInfo.title + ':'" :rules="rules">

      <template
          v-if="formItemInfo.type === 'timer' || formItemInfo.type === 'beginTime' || formItemInfo.type === 'endTime'">
        <el-date-picker size="mini" class="input-width" v-model="value1" type="date"
                        placeholder="选择日期"></el-date-picker>
      </template>

      <template v-else-if="formItemInfo.type === 'car_num' || formItemInfo.type === 'car'">
        <el-input size="mini" class="input-width" v-model="value1" placeholder="请输入车牌号码"></el-input>
      </template>

      <template v-else-if="formItemInfo.type === 'file'">
        <el-input size="mini" class="input-width" v-model="value1" placeholder="请上传图片"></el-input>
      </template>

      <template
          v-else-if="formItemInfo.type === 'input' || formItemInfo.type === 'company' || formItemInfo.type === 'comments'">
        <el-input size="mini" class="input-width" v-model="value1" placeholder="请输入文本"></el-input>
      </template>

      <template v-else-if="formItemInfo.type === 'number'">
        <el-input size="mini" class="input-width" v-model="value1" placeholder="请输入数字"></el-input>
      </template>

      <template v-else-if="formItemInfo.type === 'list'">
        <el-input size="mini" class="input-width" v-model="value1" placeholder="请输入姓名"></el-input>
      </template>
      <template v-else-if="formItemInfo.type === 'peer' || formItemInfo.type === 'accompany'">
        <div class="input-width colorbj">
          <div class="border"><span class="peer-left">姓名：</span><span class="peer-right-must">必填</span></div>
          <div class="border"><span class="peer-left">电话号码：</span><span class="peer-right-must">必填</span></div>
          <div class="border"><span class="peer-left">邮箱地址：</span><span class="peer-right-choise">选填</span>
          </div>
        </div>
      </template>

      <template v-else-if="formItemInfo.type === 'picker' || formItemInfo.type === 'address' ">
        <el-select v-model="value1" class="input-width" placeholder="请选择">
          <el-option v-for="item in slelectOption" :key="item.value" :label="item.value" :value="item.value">
          </el-option>
        </el-select>
      </template>
      <template v-else-if="formItemInfo.type === 'reason'">
        <el-select v-model="value1" class="input-width" placeholder="请选择">
          <el-option v-for="item in slelectOption" :key="item.value" :label="item.value" :value="item.value">
          </el-option>
        </el-select>
      </template>

      <template v-if="hasBtns">
        <el-button @click="onEdit" size="mini" type="primary">编辑</el-button>
        <el-button @click="onDel" size="mini" type="danger">删除</el-button>
        <el-button @click="onUp" size="mini" type="success" :disabled="upDisable">上移</el-button>
        <el-button @click="onDown" size="mini" type="warning" :disabled="downDisable">下移</el-button>
      </template>
    </el-form-item>


    <el-drawer class="drawer-content " :title="drawerData.title" :visible.sync="drawerShow" :with-header="false"
               direction="rtl" size="550px" :before-close="onDrawerClosse">

      <div class="container">
        <header>{{ drawerData.title }}</header>
        <main>
          <el-form style="padding: 50px;" size="mini" ref="form" :model="drawerData">
            <el-form-item label="名称:">
              <el-input :disabled="drawerData.disabled" class="input-width"
                        v-model="drawerData.title"></el-input>
            </el-form-item>
            <el-form-item label="必填:">
              <el-checkbox label="必填" v-model="drawerData.required"></el-checkbox>

            </el-form-item>
            <el-form-item label="类型:">
              <el-select :disabled="drawerData.disabled" class="input-width" v-model="drawerData.type">
                <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <template
                v-if="drawerData.type === 'picker' || drawerData.type === 'reason' || drawerData.type === 'company' || drawerData.type === 'address'">
              <el-form-item label="数据:">
                <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
                          size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
                </el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 数据</el-button>
              </el-form-item>

              <el-collapse style="padding-left: 20px" v-model="drawerActiveNames" @change="drawerHandleChange">
                <el-collapse-item v-for="(item, index) in slelectOption" :name="item.value" :key="item.value">
                  <template slot="title">
                    <h3 style="margin-right: 20px">选项值:</h3>
                    <el-input size="mini" :disabled="true" class="input-width" v-model="item.value"></el-input>
                    <el-button @click="onDelValueItem(index)" size="mini" type="danger">删除</el-button>
                  </template>
                  <el-form-item label="依赖选项:">
                    <el-select class="input-width" v-model="item.dependField" clearable>
                      <el-option v-for="item in dependFieldOption" :key="item.id" :label="item.title" :value="item.id">
                      </el-option>
                    </el-select>

                  </el-form-item>
                  <el-form-item label="是否只读:">
                    <el-checkbox label="只读" :true-label="1" :false-label="0" v-model="item.isReadyOnly"></el-checkbox>
                  </el-form-item>
                  <el-form-item label="依赖数据:">
                    <el-input class="input-width" :disabled="!item.isReadyOnly" v-model="item.readyValue"></el-input>
                  </el-form-item>
                  <el-form-item v-if="drawerData.type === 'reason'" label="签离时间:">
                    <el-input class="input-width" :disabled="item.signOutTime === ''" v-model="item.signOutTime">
                      <template slot="append">分钟</template>
                    </el-input>
                    <el-switch v-model="signOutTimeSwitchList[item.value]"
                               @change="onSwitchChange(item, signOutTimeSwitchList[item.value])"></el-switch>
                  </el-form-item>
                </el-collapse-item>

              </el-collapse>

            </template>
          </el-form>
        </main>
        <footer>
          <div>
            <el-button type="primary" size="mini" @click="onSaveClick">保存</el-button>
          </div>
          <div style="width: 12px;"></div>
          <div>
            <el-button size="mini" @click="onCancelClick">取消</el-button>
          </div>
        </footer>

      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  props: ['formItemInfo', 'itemIndex', 'listSize', 'formData'],

  data() {
    return {
      drawerShow: false,

      hasBtns: true,
      rules: [{required: false}],

      value1: "",

      slelectOption: [],
      dependFieldOption: [],

      drawerData: {
        title: "",
        required: false,
        type: "",
        disabled: false,
      },

      typeList: [
        {label: "下拉选择", value: "picker"},
        {label: "文本输入", value: "input"},
        {label: "时间选择", value: "timer"},
        // {label: "图片上传", value: "file"},
        {label: "数字输入", value: "number"},
      ],
      inputVisible: false,
      inputValue: '',
      drawerActiveNames: [],
      signOutTimeSwitchList: {},
    }
  },
  mounted() {
    this.drawerData.title = this.formItemInfo.title
    this.drawerData.type = this.formItemInfo.type
    if (this.formItemInfo.id <= 3) {
      this.hasBtns = false
    }
    switch (this.formItemInfo.name) {
      case 'reason':
      case 'unit':
      case 'visitAddress':
      case 'carNumber':
      case 'note':
      case 'peer':
        this.drawerData.disabled = true
        break
      default:
        break
    }
    this.drawerData.required = this.formItemInfo.required != 0

    if (this.drawerData.type === 'picker' || this.drawerData.type === 'reason') {
      let list = this.formItemInfo.valueList
      if (list) {
        this.slelectOption = JSON.parse(list)

      }
    }

    if (this.drawerData.required) {
      this.rules = [{required: true}]
    } else {
      this.rules = [{required: false}]
    }
  },

  computed: {
    upDisable: function () {
      return this.itemIndex <= 2;
    },
    downDisable: function () {
      return this.itemIndex == (this.listSize - 1);
    },
  },

  methods: {
    onDelValueItem(index) {
      this.slelectOption.splice(index, 1)
    },
    handleClose(tag) {
      this.slelectOption.splice(this.slelectOption.indexOf(tag), 1);
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.slelectOption.push({value: inputValue});
      }
      this.inputVisible = false;
      this.inputValue = '';
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    checkChange() {
      if (this.drawerData.required) {
        this.formItemInfo.required = 1
        this.rules = [{required: true}]
      } else {
        this.formItemInfo.required = 0
        this.rules = [{required: false}]
      }

      if (!this.drawerData.disabled) {
        this.formItemInfo.title = this.drawerData.title
        this.formItemInfo.type = this.drawerData.type
      }
      if (this.drawerData.type === 'picker' || this.drawerData.type === 'reason') {
        this.formItemInfo.valueList = JSON.stringify(this.slelectOption)
      }
    },

    onEdit() {
      this.drawerShow = true
      this.dependFieldOption = []
      this.formData.forEach((item) => {
        if (item.name !== this.formItemInfo.name && item.name !== "startTime" && item.name !== "endTime") {
          this.dependFieldOption.push(item)
        }
      })

      if (this.drawerData.type === 'reason') {
        this.slelectOption.forEach(item => {
          this.signOutTimeSwitchList[item.value] = item.signOutTime !== '';

        })
      }

    },
    onDel() {
      this.$emit('message', this.itemIndex, 'del')
    },
    onUp() {
      this.$emit('message', this.itemIndex, 'up')
    },
    onDown() {
      this.$emit('message', this.itemIndex, 'down')
    },
    onDrawerClosse(done) {
      done()
    },
    onCancelClick() {
      this.drawerShow = false
    },

    onSaveClick() {
      this.checkChange()
      this.drawerShow = false
    },

    drawerHandleChange(val) {
      console.log(val);
    },
    onSwitchChange(item, switchState) {
      if (switchState) {
        item.signOutTime = '30'
      } else {
        item.signOutTime = ''
      }
    }
  }
}

</script>

<style lang="less" scoped>
.line_more {
  display: block;
}

.input-width {
  width: 220px;
  margin-right: 10px;

}

.colorbj {
  display: inline-block;
  background-color: white;
  border: 1px solid gainsboro;
  border-radius: 5px;
}

.drawer-title {
  padding-left: 10px;
  padding-top: 10px;
}

.border {
  border: 1px solid gainsboro;
}

.peer-left {
  display: inline-block;
  padding-left: 15px;
  width: 94px;
}

.peer-right-must {
  width: 94px;
  display: inline-block;
  padding-right: 15px;

  color: darkred;
  text-align: right;
}

.peer-right-choise {
  display: inline-block;
  width: 94px;
  padding-right: 15px;
  text-align: right;

}

.container {
  display: flex;
  flex-direction: column;
  height: 100vh;

  /* 设置容器高度占满整个视口 */


  header {
    height: 50px;
    line-height: 50px;
    padding-left: 12px;
    /* 固定头部高度 */
    border-bottom: 1px solid gray;
  }

  main {
    flex: 1;
    /* 中间内容自动拉伸 */
    border-bottom: 1px solid gray;

    padding: 12px;

  }

  footer {
    height: 50px;
    display: flex;
    justify-content: center;

    div {
      height: 50px;
      line-height: 50px;
    }

    /* 固定底部高度 */
  }

  .button-ensure {
    margin: 0 10px;
    /* 左右间距 */
  }

  .button-cancel {
    margin: 0 10px;
    /* 左右间距 */
  }
}

.tag-item {
  display: inline-block;
  margin-right: 12px;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
